export const settingMenus = () => ({
    Id: 14,
    id: `main-menu-2-all`,
    path: '/management/settings/cms',
    label: 'Settings',
    Description: 'Settings panel enables the user to configure the appearance or actions in an platform..',
    isEnabled: true,
    svg: (
        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#ffffff" d="M19.14 12.936a7.965 7.965 0 0 0 .063-.936c0-.316-.023-.627-.063-.936l2.048-1.6a.5.5 0 0 0 .124-.625l-1.938-3.352a.5.5 0 0 0-.6-.225l-2.41.96a7.924 7.924 0 0 0-1.62-.936l-.363-2.567A.5.5 0 0 0 14.51 2h-5.02a.5.5 0 0 0-.495.42l-.363 2.567a7.924 7.924 0 0 0-1.62.936l-2.41-.96a.5.5 0 0 0-.6.225L2.585 9.4a.5.5 0 0 0 .124.625l2.048 1.6c-.04.309-.063.62-.063.936 0 .316.023.627.063.936l-2.048 1.6a.5.5 0 0 0-.124.625l1.938 3.352a.5.5 0 0 0 .6.225l2.41-.96c.504.365 1.043.674 1.62.936l.363 2.567a.5.5 0 0 0 .495.42h5.02a.5.5 0 0 0 .495-.42l.363-2.567a7.924 7.924 0 0 0 1.62-.936l2.41.96a.5.5 0 0 0 .6-.225l1.938-3.352a.5.5 0 0 0-.124-.625l-2.048-1.6zm-7.14 2.064a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
        </svg>

    ),

    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'CMS Settings',
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M19.14 12.936a7.965 7.965 0 0 0 .063-.936c0-.316-.023-.627-.063-.936l2.048-1.6a.5.5 0 0 0 .124-.625l-1.938-3.352a.5.5 0 0 0-.6-.225l-2.41.96a7.924 7.924 0 0 0-1.62-.936l-.363-2.567A.5.5 0 0 0 14.51 2h-5.02a.5.5 0 0 0-.495.42l-.363 2.567a7.924 7.924 0 0 0-1.62.936l-2.41-.96a.5.5 0 0 0-.6.225L2.585 9.4a.5.5 0 0 0 .124.625l2.048 1.6c-.04.309-.063.62-.063.936 0 .316.023.627.063.936l-2.048 1.6a.5.5 0 0 0-.124.625l1.938 3.352a.5.5 0 0 0 .6.225l2.41-.96c.504.365 1.043.674 1.62.936l.363 2.567a.5.5 0 0 0 .495.42h5.02a.5.5 0 0 0 .495-.42l.363-2.567a7.924 7.924 0 0 0 1.62-.936l2.41.96a.5.5 0 0 0 .6-.225l1.938-3.352a.5.5 0 0 0-.124-.625l-2.048-1.6zm-7.14 2.064a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                </svg>

            ),
            path: '/management/settings/cms',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Organization Settings',
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M19.14 12.936a7.965 7.965 0 0 0 .063-.936c0-.316-.023-.627-.063-.936l2.048-1.6a.5.5 0 0 0 .124-.625l-1.938-3.352a.5.5 0 0 0-.6-.225l-2.41.96a7.924 7.924 0 0 0-1.62-.936l-.363-2.567A.5.5 0 0 0 14.51 2h-5.02a.5.5 0 0 0-.495.42l-.363 2.567a7.924 7.924 0 0 0-1.62.936l-2.41-.96a.5.5 0 0 0-.6.225L2.585 9.4a.5.5 0 0 0 .124.625l2.048 1.6c-.04.309-.063.62-.063.936 0 .316.023.627.063.936l-2.048 1.6a.5.5 0 0 0-.124.625l1.938 3.352a.5.5 0 0 0 .6.225l2.41-.96c.504.365 1.043.674 1.62.936l.363 2.567a.5.5 0 0 0 .495.42h5.02a.5.5 0 0 0 .495-.42l.363-2.567a7.924 7.924 0 0 0 1.62-.936l2.41.96a.5.5 0 0 0 .6-.225l1.938-3.352a.5.5 0 0 0-.124-.625l-2.048-1.6zm-7.14 2.064a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                </svg>

            ),
            path: '/management/settings/organizations',
            isEnabled: true,

        },
        {
            id: `coln-1-Categories`,
            label: 'Global Settings',
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M19.14 12.936a7.965 7.965 0 0 0 .063-.936c0-.316-.023-.627-.063-.936l2.048-1.6a.5.5 0 0 0 .124-.625l-1.938-3.352a.5.5 0 0 0-.6-.225l-2.41.96a7.924 7.924 0 0 0-1.62-.936l-.363-2.567A.5.5 0 0 0 14.51 2h-5.02a.5.5 0 0 0-.495.42l-.363 2.567a7.924 7.924 0 0 0-1.62.936l-2.41-.96a.5.5 0 0 0-.6.225L2.585 9.4a.5.5 0 0 0 .124.625l2.048 1.6c-.04.309-.063.62-.063.936 0 .316.023.627.063.936l-2.048 1.6a.5.5 0 0 0-.124.625l1.938 3.352a.5.5 0 0 0 .6.225l2.41-.96c.504.365 1.043.674 1.62.936l.363 2.567a.5.5 0 0 0 .495.42h5.02a.5.5 0 0 0 .495-.42l.363-2.567a7.924 7.924 0 0 0 1.62-.936l2.41.96a.5.5 0 0 0 .6-.225l1.938-3.352a.5.5 0 0 0-.124-.625l-2.048-1.6zm-7.14 2.064a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                </svg>

            ),
            path: '/management/settings/global-settings/global',
            isEnabled: true,
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Global Settings',
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#007BFF" d="M19.14 12.936a7.965 7.965 0 0 0 .063-.936c0-.316-.023-.627-.063-.936l2.048-1.6a.5.5 0 0 0 .124-.625l-1.938-3.352a.5.5 0 0 0-.6-.225l-2.41.96a7.924 7.924 0 0 0-1.62-.936l-.363-2.567A.5.5 0 0 0 14.51 2h-5.02a.5.5 0 0 0-.495.42l-.363 2.567a7.924 7.924 0 0 0-1.62.936l-2.41-.96a.5.5 0 0 0-.6.225L2.585 9.4a.5.5 0 0 0 .124.625l2.048 1.6c-.04.309-.063.62-.063.936 0 .316.023.627.063.936l-2.048 1.6a.5.5 0 0 0-.124.625l1.938 3.352a.5.5 0 0 0 .6.225l2.41-.96c.504.365 1.043.674 1.62.936l.363 2.567a.5.5 0 0 0 .495.42h5.02a.5.5 0 0 0 .495-.42l.363-2.567a7.924 7.924 0 0 0 1.62-.936l2.41.96a.5.5 0 0 0 .6-.225l1.938-3.352a.5.5 0 0 0-.124-.625l-2.048-1.6zm-7.14 2.064a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                        </svg>

                    ),
                    path: '/management/settings/global-settings/global',
                    isEnabled: true,

                },



            ],
        },


    ],
}
)
